import React, { Component } from 'react';
import { Divider, Switch, Button, NumericInput } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class AFKSystem extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      AFKSystem: true,
      AFKMinutes: 7,
    };

    this.handleChange = (Name) => (Value) => {
      if (typeof this.state[Name] === 'boolean')
        this.setState({ [Name]: !this.state[Name] });
      else if (Value.target) this.setState({ [Name]: Value.target.value });
      else this.setState({ [Name]: Value });
    };
  }

  render() {
    const SwitchOnOff = { innerLabelChecked: 'on', innerLabel: 'off' };

    return (
      <SideMenuWrapper>
        <h3
          className="display-4 font-italic mb-4"
          style={{ fontSize: '1.5rem' }}
        >
          AFK System
        </h3>

        <Divider />

        <table className="bp3-html-table bp3-html-table-bordered bp3-interactive html-table-row-border">
          <tbody>
            <tr>
              <td style={{ minWidth: '150px' }}>AFK System</td>
              <td>
                <Switch
                  checked={this.state.AFKSystem}
                  {...SwitchOnOff}
                  onChange={this.handleChange('AFKSystem')}
                />
              </td>
            </tr>

            <tr>
              <td>AFK Minutes</td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  disabled={!this.state.AFKSystem}
                  style={{ width: '120px' }}
                  value={this.state.AFKMinutes}
                  placeholder="Type minutes..."
                  onValueChange={this.handleChange('AFKMinutes')}
                  className="mb-4"
                  min={0}
                />
              </td>
            </tr>

            <tr>
              <td></td>
              <td>
                <Button className="mt-2" icon="floppy-disk" text="Save" />
              </td>
            </tr>
          </tbody>
        </table>
      </SideMenuWrapper>
    );
  }
}
